//@flow
import React, { useState } from 'react';
import type { Neighbourhood, NeighbourhoodTypes } from 'types/project';
import { NeighbourhoodCard } from 'components/molecules/neighbourhoodCard';
import SimpleBar from 'simplebar-react';
import MapComponent from 'components/molecules/map';
import { NeighbourhoodFilterView } from 'components/atoms/neighbourhoodFilterView';
import { ProjectMapper } from 'mappers/project';
import { ProjectActions } from 'modules/project/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

type Props = {
  data: {
    list: Array<Neighbourhood>,
    project: Object,
    types: Array<NeighbourhoodTypes>,
  },
  mediaPath: string,
  toggleNeighbourhoodFilter: () => void,
  activeFilter: Object<NeighbourhoodTypes>,
  filteredNeighbourHood: Array<Neighbourhood>,
  filterImage?: string,
};

const NeighbourhoodOverlay = (props: Props) => {
  const {
    data,
    toggleNeighbourhoodFilter,
    filteredNeighbourHood,
    filterImage,
  } = props;
  const [selectedItemId, updateSelectedItemId] = useState(null);
  const [clonedArray, setClonedArray] = useState([
    { ...ProjectMapper.allNeighbourhoodFilter },
    ...data.types.map(type => ({ ...type, isActive: false })),
  ]);
  const { height } = useViewport();

  const toggleFilter = val => {
    const updatedArray = clonedArray.map(item => ({
      ...item,
      isActive: item.id === val.id,
    }));
    setClonedArray(updatedArray);
    toggleNeighbourhoodFilter(val.id === 'all' ? null : val);
  };

  const renderFilter = () => {
    return (
      <div className={'neighbourhood-filter-container'}>
        {clonedArray &&
          clonedArray.map((item, idx) => (
            <NeighbourhoodFilterView
              key={idx}
              title={item.title}
              onClick={() => toggleFilter(item)}
              imageSrc={item.isActive ? item.activeImgSrc : item.imageSource}
              isActive={item.isActive}
            />
          ))}
      </div>
    );
  };
  return (
    <div className={'neighbourhood-overlay-container'}>
      {renderFilter()}
      <div className={'left-content'}>
        <SimpleBar autoHide={false} style={{ height: '100%' }}>
          {filteredNeighbourHood &&
            filteredNeighbourHood.map((item, idx) => (
              <NeighbourhoodCard
                key={idx}
                name={item.name}
                location={item.location}
                distance={item.distance}
                typeId={item.neighbourhoodTypeId}
                imagePath={item.listImageUrl}
                selectedItemId={selectedItemId}
                filterImage={filterImage}
              />
            ))}
        </SimpleBar>
      </div>
      <div className={'right-content'}>
        <MapComponent
          mapStyles={'project-map'}
          data={filteredNeighbourHood}
          type={'neighbourhood'}
          pinLocation={data.project}
          types={data.types}
          updateFilter={e => updateSelectedItemId(e.neighbourhoodTypeId)}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  const { toggleNeighbourhoodFilter } = ProjectActions;
  return bindActionCreators(
    {
      toggleNeighbourhoodFilter,
    },
    dispatch
  );
};

const connectedComponent = connect(
  null,
  mapDispatchToProps
)(NeighbourhoodOverlay);

export default withRouter(connectedComponent);
